export const User = () => (
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-2 -2)" fill="none" fillRule="evenodd">
      <path d="M7 16h10a5 5 0 015 5 1 1 0 01-1.993.117l-.012-.293a3 3 0 00-2.819-2.819L17 18H7a3 3 0 00-3 3 1 1 0 01-2 0 5 5 0 014.783-4.995L7 16h10H7zm5-14a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8z" />
    </g>
  </svg>
)
